import { Link } from 'react-router-dom';
import './product-chrome.css';

export function ProductFooter() {
  return (
    <footer className="product-footer">
      <div className="product-footer__inner">
        <nav className="product-footer__links">
          <a href="https://www.paazio.com">Home</a>
          <a href="/tuition/login">Tuition</a>
          <a href="/assess/login">Assess</a>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
        </nav>
        <p className="product-footer__copy">
          &copy; {new Date().getFullYear()} Paazio. All rights reserved.
        </p>
        <p className="product-footer__copy">
          Paazio is a product from Suriyan Infotech Private Limited.
        </p>
      </div>
    </footer>
  );
}
